module.exports = __webpack_public_path__ + "img/葫芦娃.b69d002c.gif";